/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql ,Link } from "gatsby"

import Header from "./header"
import "./layout.css"

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <>
    <nav class="navbar bg-primary text-white fixed-top">
<Link to="/" class="text-white">Home</Link>
<Link to="/price" class="text-white">Price</Link>
<Link to="/contact" class="text-white">Contact</Link>
      </nav>
 <div class="col-12 col-md-12 p-3 p-md-5 bg-primary text-white">
      <Header siteTitle={data.site.siteMetadata.title} /></div>
           <main>{children}</main>
        <footer class="bg-primary text-white text-center">
        <small><small>© {new Date().getFullYear()}, Built with
          {` `}
          <a class="text-white" href="https://www.gatsbyjs.org" target="blank">Gatsby</a>
          </small></small></footer>
     
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
